import { render, staticRenderFns } from "./AddCustomBadgeDialog.vue?vue&type=template&id=38edc11a&scoped=true&"
import script from "./AddCustomBadgeDialog.vue?vue&type=script&lang=js&"
export * from "./AddCustomBadgeDialog.vue?vue&type=script&lang=js&"
import style0 from "./AddCustomBadgeDialog.vue?vue&type=style&index=0&id=38edc11a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38edc11a",
  null
  
)

export default component.exports